// extracted by mini-css-extract-plugin
module.exports = {"TicketIcon":"BuyTickets_TicketIcon__2Pg5t","BigFormat":"BuyTickets_BigFormat__26vQn"};